module.exports = __webpack_public_path__ + "static/offices-content-image-1-e32908e5d1f06487bcd2214581963e80.jpg";